import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { Reducer, combineReducers } from 'redux';
// import productReducer from '../pages/ProductPage/reducer';
import loading from './reducers/loading';
import message from './reducers/message';

export default function reducers(history: History): Reducer {
    return combineReducers({
        // @ts-ignore
        router: connectRouter(history),
        loading,
        message,
    });
}
